export const CODE_SPENT = 'code_spent';
export const EXPIRED = 'expired';
export const STOPPED = 'stopped';
export const PUBLISHED = 'published';
export const PUBLISHED_SOON = 'published_soon';
export const PUBLISHED_UPDATE = 'published_update';
